import { AdminWorks } from 'components/AdminWorks';
import { WorkerWork } from 'components/WorkerWork';
import { userStore } from 'stores';

export const MyWorks = () => {
	return userStore.isStaff ? <AdminWorks /> : <WorkerWork />;
};

